export enum HolUserRights {
  READ = 'READ',
  WRITE = 'WRITE',
  UNAUTHORIZED = 'UNAUTHORIZED',
}
